"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Rocket = function Rocket(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M14.5 15.135c0 .396-.09.787-.264 1.143l-.231.463a.469.469 0 01-.42.259h-3.17c-.178 0-.34-.1-.42-.26l-.231-.462a2.605 2.605 0 01-.264-1.143l-1.787 1.787a.234.234 0 01-.4-.166v-2.04c0-.332.131-.65.366-.885l1.73-1.73a.312.312 0 00.091-.22V9.5c0-3.964 1.563-5.625 2.5-5.625.938 0 2.5 1.66 2.5 5.625v2.38c0 .083.033.163.092.221l1.73 1.73c.234.235.366.553.366.884v2.041a.234.234 0 01-.4.166L14.5 15.135zm-2.5 2.49a1.33 1.33 0 011.25 1.406c0 .892-.839 2.344-1.25 2.344-.411 0-1.25-1.452-1.25-2.344A1.33 1.33 0 0112 17.625z"
  }));
};

var _default = (0, _react.forwardRef)(Rocket);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Rocket, "Rocket", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Rocket.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Rocket.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();